import { createContext, useContext } from 'react';

import type { UserProfile } from '../types/userProfile';

export type UserContextType = {
  error?: Error | null;
  loading: boolean;
  userProfile: UserProfile | null;
  getUserProfile: () => Promise<void>;
};

export const UserProfileContext = createContext<UserContextType | null>(null);

export function useUserProfile() {
  const context = useContext(UserProfileContext);
  if (context === null) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context.userProfile;
}

/**
 * True while GET /v1/user is in flight. UserProfileProvider renders its children
 * during that request, so anything that depends on the user waits for this.
 */
export function useIsUserProfileLoading() {
  const context = useContext(UserProfileContext);
  if (context === null) {
    throw new Error('useIsUserProfileLoading must be used within a UserProfileProvider');
  }
  return context.loading;
}
